import { Locale, type LocalizedString } from "../Locale.js";

export const serviceLogisticsPathMap = {
	[Locale.cs]: "logistika-skladu" as const,
} satisfies LocalizedString;
